import React, { Component } from 'react';
import _ from 'lodash'
import * as rd from "diacritics"

import { Table, Button, Well, Grid, Row, Col, FormControl, ButtonToolbar, ToggleButtonGroup, ToggleButton } from 'react-bootstrap';

import { usersList, usersRequesitionsList } from '../../dao-firebase/daofirebase'
import { inactiveUser } from '../../dao-firebase/user-firebase'

import If from "../../utils/If"
import PaginationComponent from "../../utils/pagination-component"
import { formatJsDateToPt, difDates } from "../../utils/functions"

import Loader from 'react-loader-advanced';

import '../../statics/css/user-list.css'
import moment from 'moment'

const itensOnPage = 10

class ListAlunos extends Component {

  constructor(props) {
    super(props);

    this.state = {
      alunos: [],
      registereds_alunos: [],
      to_show_registereds_alunos: [],
      alunosBirthday: [],

      //search
      search_table_users: '',
      filter_by_status: 1,
      filter_by_time_training: 1,
      filter_by_contract_date: 1,

      //Pagination Reqs
      usersReqCount: undefined,
      //pgination
      beginPaginationReq: 1,
      endPaginationReq: itensOnPage,
      activePageReq: 1,
      indexOkReq: true,

      //Pagination countItensAlunos
      usersCount: undefined,
      //pgination
      beginPagination: 1,
      endPagination: itensOnPage,
      activePage: 1,
      indexOk: true,

      paginationComponent: null,

      //Pagination countItensAlunos
      usersCountBirthday: undefined,
      //pgination
      beginPaginationBirthday: 1,
      endPaginationBirthday: itensOnPage,
      activePageBirthday: 1,
      indexOkBirthday: true,
    };

  }

  componentWillMount() {

    if (JSON.parse(localStorage.getItem("USER")) == undefined || JSON.parse(localStorage.getItem("USER")) == null) {

      this.props.history.push('/login')

    } else {
      usersRequesitionsList(JSON.parse(localStorage.getItem("USER")).uid, (users) => {
        //console.log("AEOH")
        this.setState({
          alunos: users,
          usersReqCount: users.length,
        }, () => {
          //console.log('PUTS')
          //console.log(this.state.alunos)
        })
      })


      let birthdays = [];
      let birthNow = moment(new Date()).format("DD/MM")
      usersList(JSON.parse(localStorage.getItem("USER")).uid, (users) => {
        //console.log("AEOH")
        this.setState({
          registereds_alunos: users,
          usersCount: users.length,
        }, () => {
          this.applyFilter(users);

          console.log('NÚMERO DE USUÁRIOS: ' + this.state.usersCount);
          //console.log("ALL USERS: ", JSON.stringify(users));
          //console.log('PUTS')
          //console.log(this.state.registereds_alunos)          
          (this.state.registereds_alunos).forEach(element => {

            //console.log("ELEMENT: ", element)
            let now = new Date();
            now = now.getTime() / 1000;
            if (element.data.contract_date != undefined) {

              console.log(element.data.contract_date.seconds + " < " + now)
            }
            if (element.data.contract_date != undefined && element.data.contract_date.seconds < now) {
              console.log("VENCIDO: ", element);
              inactiveUser(JSON.parse(localStorage.getItem("USER")).uid, element.id, (response, success) => {

              })
            }

            //console.log("ALUNO: ", element)
            if (element.data && element.data.born_date.substring(0, 5) == birthNow) {
              birthdays.push(element);
            }

          });

          console.log("ANIVERSARIANTES: ", birthdays)
          this.setState({
            alunosBirthday: birthdays,
            usersCountBirthday: birthdays.length,
          })

        })
      })
      //this.props.history.push('/login');
    }

  }

  getAge(dateString) {
    //console.log(dateString)
    let splittedDate = dateString.split('/')
    let birthday = +new Date(splittedDate[2], splittedDate[1], splittedDate[0], 0, 0, 0, 0);
    //console.log(birthday)
    return ~~((Date.now() - birthday) / (31557600000));
  }

  selectUser(aluno) {

    this.props.history.push({
      pathname: '/aluno_detail',
      alunoSelected: aluno,
    })

  }

  onInputChange(target) {

    //console.log(target);

    let value = target.value;
    let name = target.name;

    if (name == "name_section_training") {
      this.setState({
        [name]: value.toUpperCase()
      });
    } else {
      this.setState({
        [name]: value
      }, () => {
        //console.log(name + ": " + value);
        this.applyFilter(this.state.registereds_alunos)
      });

    }

  }

  renderAlunos() {

    return _.map(this.state.alunos, (aluno, index) => {

      return (

        <If test={
          (

            (index + 1) <= this.state.endPaginationReq
            && (index + 1) >= this.state.beginPaginationReq

          )
        }>
          <tr key={aluno.id} className="item-user-list">
            <td className="middle-td td-20">
              <p>{aluno.data.name} {aluno.data.last_name ? aluno.data.last_name : ""}</p>
            </td>
            <td className="middle-td td-20">
              <p>{this.getAge(aluno.data.born_date)} anos</p>
            </td>
            <td className="middle-td td-20">
              <If test={aluno.data.gender == 'male'}>
                <p>Masculino</p>
              </If>
              <If test={aluno.data.gender == 'female'}>
                <p>Feminino</p>
              </If>
              <If test={aluno.data.gender == 'Outro'}>
                <p>Outro</p>
              </If>
            </td>
            <td className="middle-td td-20">
              <p>{aluno.data.service == 'consult' ? 'Consultoria Esportiva' : 'Personal Trainer'}</p>
            </td>
            <td className="middle-td">
              <If test={aluno.data.status == 'WAIT_ACCEPT'}>
                <Button bsStyle="primary" onClick={() => this.selectUser(aluno)}>Aguardando aceitação</Button>
              </If>
              {/* <If test={aluno.data.status == 'WAIT_ACCEPT'}>
              <p>Outro</p>
            </If> */}
            </td>

          </tr>

        </If >



      )
    })
  }

  renderAlunosBirthday() {

    return _.map(this.state.alunosBirthday, (aluno, index) => {

      let stringPtDateTimeTraining = null;
      let difDaysTimeTraining = 0;
      let statusByTimeTraining = 1;
      let colorTimeTraining = "green";

      if (aluno.data.training) {

        //Caso return null é porque ainda não possui vencimento para o treino
        stringPtDateTimeTraining = formatJsDateToPt(aluno.data.training.training_time);
        difDaysTimeTraining = difDates(new Date(), stringPtDateTimeTraining);

        if (difDaysTimeTraining <= 0) {
          colorTimeTraining = "red";
          statusByTimeTraining = 3;
        } else if (difDaysTimeTraining > 0 && difDaysTimeTraining <= 5) {
          colorTimeTraining = "yellow";
          statusByTimeTraining = 2;
        }
      }

      let stringPtDateContractDate = null;
      let difDaysContractDate = 0;
      let statusByContractDate = 1;
      let colorContractDate = "green";

      if (aluno.data.contract_date) {

        //Caso return null é porque ainda não possui vencimento para o treino
        stringPtDateContractDate = formatJsDateToPt(aluno.data.contract_date);
        difDaysContractDate = difDates(new Date(), stringPtDateContractDate);

        if (difDaysContractDate <= 0) {
          colorContractDate = "red";
          statusByContractDate = 3;
        } else if (difDaysContractDate > 0 && difDaysContractDate <= 5) {
          colorContractDate = "yellow";
          statusByContractDate = 2;
        }
      }

      //console.log("INDEX: " + index);

      return (


        <If key={aluno.id}
          test={
            (

              (this.state.filter_by_status == 1
                || this.state.filter_by_status == statusByTimeTraining)

              &&

              (this.state.filter_by_time_training == 1
                || this.state.filter_by_time_training == statusByTimeTraining)

              &&

              (this.state.filter_by_contract_date == 1
                || this.state.filter_by_contract_date == statusByContractDate)

              && (
                (
                  this.state.search_table_users == ''
                  && (index + 1) <= this.state.endPagination
                  && (index + 1) >= this.state.beginPagination
                )
                ||
                (this.state.search_table_users != '' && this.verifySearch(aluno.data)))
            )
          }>

          <tr className="item-user-list">
            <td className="middle-td td-20">
              <p>{aluno.data.name} {aluno.data.last_name ? aluno.data.last_name : ""}</p>
            </td>
            <td className="middle-td">
              <p>{this.getAge(aluno.data.born_date)} anos</p>
            </td>
            {/* <td className="middle-td">
              <If test={aluno.data.gender == 'male'}>
                <p>Masculino</p>
              </If>
              <If test={aluno.data.gender == 'female'}>
                <p>Feminino</p>
              </If>
              <If test={aluno.data.gender == 'Outro'}>
                <p>Outro</p>
              </If>
            </td> */}
            <td className="middle-td td-20">
              <p>{aluno.data.service == 'consult' ? 'Consultoria Esportiva' : 'Personal Trainer'}</p>
            </td>
            <td className="middle-td td-20">
              {/* Verifica-se se existe data de vencimento do treino */}
              {stringPtDateContractDate != null ?
                <p>{stringPtDateContractDate} [ <span className={`bold ${colorContractDate}`}>{difDaysContractDate} dias</span> ]</p>
                :
                <p className="bold red">Não informado</p>
              }

            </td>
            <td className="middle-td td-20">
              {/* Verifica-se se existe data de vencimento do treino */}
              {stringPtDateTimeTraining != null ?
                <p>{stringPtDateTimeTraining} [ <span className={`bold ${colorTimeTraining}`}>{difDaysTimeTraining} dias</span> ]</p>
                :
                <p className="bold red">Não informado</p>
              }

            </td>
            <td className="middle-td">
              {aluno.data.status == "ACTIVE" ?
                <Button bsStyle="success" onClick={() => this.selectUser(aluno)}>Detalhar</Button>
                :
                <Button bsStyle="warning" onClick={() => this.selectUser(aluno)}>Detalhar</Button>
              }
            </td>

          </tr>

        </If >

      )
    })
  }

  verifySearch(obj) {

    let nameObjFormat = rd.remove(obj.name.toLowerCase());
    let searchFormat = rd.remove(this.state.search_table_users.toLowerCase());
    return nameObjFormat.includes(searchFormat);
  }

  onChangePagination(p, begin, end) {

    this.setState({
      beginPagination: begin,
      endPagination: end,
      activePage: p,
    }, () => {
      console.log("Active: ", this.state.activePage,
        " - Begin: ", this.state.beginPagination,
        " - End: ", this.state.endPagination)
      //this.applyFilter(this.state.registereds_alunos)
    })

  }

  onChangePaginationReq(p, begin, end) {

    this.setState({
      beginPaginationReq: begin,
      endPaginationReq: end,
      activePageReq: p,
    }, () => {
      console.log("Active: ", this.state.activePageReq,
        " - Begin: ", this.state.beginPaginationReq,
        " - End: ", this.state.endPaginationReq)

      //Trazendo scroll pra 0 pra garantir a visibilidade da mensagem
      //window.scrollTo(0, 0);

    })

  }

  onChangePaginationBirthday(p, begin, end) {

    this.setState({
      beginPaginationBirthday: begin,
      endPaginationBirthday: end,
      activePageBirthday: p,
    }, () => {

    })

  }

  renderAlunosFinais() {

    return _.map(this.state.to_show_registereds_alunos, (aluno, index) => {

      //console.log('TESTE: ', this.state.filter_by_status);     

      //console.log("INDEX: " + index);
      if ((
        (
          this.state.search_table_users == ''
          && (index + 1) <= this.state.endPagination
          && (index + 1) >= this.state.beginPagination
        )
        ||
        (this.state.search_table_users != '' && this.verifySearch(aluno.data)))) {

        return (

          <tr className="item-user-list">
            <td className="middle-td td-20">
              <p>{aluno.data.name} {aluno.data.last_name ? aluno.data.last_name : ""}</p>
            </td>
            <td className="middle-td">
              <p>{this.getAge(aluno.data.born_date)} anos</p>
            </td>
            {/* <td className="middle-td">
                  <If test={aluno.data.gender == 'male'}>
                    <p>Masculino</p>
                  </If>
                  <If test={aluno.data.gender == 'female'}>
                    <p>Feminino</p>
                  </If>
                  <If test={aluno.data.gender == 'Outro'}>
                    <p>Outro</p>
                  </If>
                </td> */}
            <td className="middle-td">
              <p>{aluno.data.service == 'consult' ? 'C.E' : 'P.T'}</p>
            </td>
            <td className="middle-td td-20">
              {/* Verifica-se se existe data de vencimento do treino */}
              {aluno.stringPtDateContractDate != null ?
                <p>{aluno.stringPtDateContractDate} [ <span className={`bold ${aluno.colorContractDate}`}>{aluno.difDaysContractDate} dias</span> ]</p>
                :
                <p className="bold red">Não informado</p>
              }

            </td>
            <td className="middle-td">
              {/* Verifica-se se existe data de vencimento do treino */}
              {aluno.stringPtDateTimeTraining != null ?
                <p>{aluno.stringPtDateTimeTraining} [ <span className={`bold ${aluno.colorTimeTraining}`}>{aluno.difDaysTimeTraining} dias</span> ]</p>
                :
                <p className="bold red">Não informado</p>
              }

            </td>
            <td className="middle-td">
              {aluno.data.status == "ACTIVE" ?
                <Button bsStyle="success" onClick={() => this.selectUser(aluno)}>Detalhar</Button>
                :
                <Button bsStyle="warning" onClick={() => this.selectUser(aluno)}>Detalhar</Button>
              }
            </td>

          </tr>

        )
      }


    })
  }

  applyFilter(alunos) {

    console.log('all list: ', alunos);
    let filteredList = [];

    console.log('filter_by_status: ', this.state.filter_by_status);
    console.log('filter_by_contract_date: ', this.state.filter_by_contract_date);
    console.log('filter_by_time_training: ', this.state.filter_by_time_training);

    for (let index = 0; index < alunos.length; index++) {

      const aluno = alunos[index];

      aluno.statusByActive = 1;
      if (aluno.data.status == 'ACTIVE') {
        aluno.statusByActive = 2
      } else {
        aluno.statusByActive = 3
      }

      //console.log('statusByActive: ', statusByActive);

      aluno.stringPtDateTimeTraining = null;
      aluno.difDaysTimeTraining = 0;
      aluno.statusByTimeTraining = 1;
      aluno.colorTimeTraining = "green";

      if (aluno.data.training) {

        //Caso return null é porque ainda não possui vencimento para o treino
        aluno.stringPtDateTimeTraining = formatJsDateToPt(aluno.data.training.training_time);
        aluno.difDaysTimeTraining = difDates(new Date(), aluno.stringPtDateTimeTraining);

        if (aluno.difDaysTimeTraining <= 0) {
          aluno.colorTimeTraining = "red";
          aluno.statusByTimeTraining = 3;
        } else if (aluno.difDaysTimeTraining > 0 && aluno.difDaysTimeTraining <= 5) {
          aluno.colorTimeTraining = "yellow";
          aluno.tatusByTimeTraining = 2;
        } else if (aluno.difDaysTimeTraining > 0) {
          aluno.statusByTimeTraining = 4;
        }
      }

      aluno.stringPtDateContractDate = null;
      aluno.difDaysContractDate = 0;
      aluno.statusByContractDate = 1;
      aluno.colorContractDate = "green";

      if (aluno.data.contract_date) {

        //Caso return null é porque ainda não possui vencimento para o treino
        aluno.stringPtDateContractDate = formatJsDateToPt(aluno.data.contract_date);
        aluno.difDaysContractDate = difDates(new Date(), aluno.stringPtDateContractDate);

        if (aluno.difDaysContractDate <= 0) {
          aluno.colorContractDate = "red";
          aluno.statusByContractDate = 3;
        } else if (aluno.difDaysContractDate > 0 && aluno.difDaysContractDate <= 5) {
          aluno.colorContractDate = "yellow";
          aluno.statusByContractDate = 2;
        }
      }

      if (

        (this.state.filter_by_status == 1
          || this.state.filter_by_status == aluno.statusByActive)

        &&

        (this.state.filter_by_time_training == 1
          || (this.state.filter_by_time_training == 4 && aluno.statusByTimeTraining == 2)
          || this.state.filter_by_time_training == aluno.statusByTimeTraining)

        &&

        (this.state.filter_by_contract_date == 1
          || this.state.filter_by_contract_date == aluno.statusByContractDate)

      ) {

        filteredList.push(aluno);

      }

    }

    console.log("FILTERED LIST: ", filteredList);
    console.log("BEGIN PAGINATION: ", this.state.beginPagination);
    console.log("END PAGINATION: ", this.state.endPagination);

    this.setState({
      to_show_registereds_alunos: filteredList,
      usersCount: filteredList.length
    }, () => {
      this.renderPagination(filteredList.length);
    })
  }

  filterUsersByStatus(statusUser) {

    this.setState({
      search_table_users: "",
      filter_by_status: statusUser,
    }, () => {
      this.applyFilter(this.state.registereds_alunos);
    })
  }
  filterUsersByTimeTraining(statusTimeTraining) {

    this.setState({
      search_table_users: "",
      filter_by_time_training: statusTimeTraining,
    }, () => {
      this.applyFilter(this.state.registereds_alunos);
    })
  }

  filterUsersByContractDate(statusContractDate) {

    this.setState({
      search_table_users: "",
      filter_by_contract_date: statusContractDate,
    }, () => {
      this.applyFilter(this.state.registereds_alunos);
    })
  }

  renderPagination(usersCount) {

    console.log("USERS COUNT IN PAGINATION: ", usersCount);

    this.setState({
      paginationComponent: null,
      beginPagination: 1,
      endPagination: itensOnPage,
      activePage: 1,
    }, () => {
      this.setState({
        paginationComponent: <PaginationComponent
          beginPagination={1}
          endPagination={itensOnPage}
          countItens={usersCount}
          activePage={1}
          itensOnPage={itensOnPage}
          onChangePage={(p, begin, end) => this.onChangePagination(p, begin, end)} />
      })
    })



  }

  render() {

    return (

      <div className="user-list-table">

        <If test={this.state.alunos && this.state.alunos.length > 0}>
          <h3 className="label-table">Requisições de novos alunos</h3>
          <Well>
            <Table responsive>
              <thead>
                <tr>
                  <th>Nome</th>
                  <th>Idade</th>
                  <th>Gênero</th>
                  <th>Serviço</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {this.renderAlunos()}
              </tbody>
            </Table>


          </Well>

          <If test={this.state.usersReqCount}>
            <PaginationComponent
              className="z-index-999"
              beginPagination={1}
              endPagination={10}
              countItens={this.state.usersReqCount}
              activePage={1}
              itensOnPage={10}
              onChangePage={(p, begin, end) => this.onChangePaginationReq(p, begin, end)} />
          </If>


        </If>


        <If test={this.state.alunosBirthday && this.state.alunosBirthday.length > 0}>

          <br />
          <br />
          <br />
          <h3 className="label-table">Aniversariantes</h3>
          <Well>
            <Table responsive>
              <thead>
                <tr>
                  <th>Nome</th>
                  <th>Idade</th>
                  <th>Serviço</th>
                  <th>Contrato</th>
                  <th>Treino</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {this.renderAlunosBirthday()}
              </tbody>
            </Table>


          </Well>

          <If test={this.state.usersReqCount}>
            <PaginationComponent
              className="z-index-999"
              beginPagination={1}
              endPagination={10}
              countItens={this.state.usersCountBirthday}
              activePage={1}
              itensOnPage={10}
              onChangePage={(p, begin, end) => this.onChangePaginationReq(p, begin, end)} />
          </If>


        </If>

        <Grid>
          <Row className="flex-row toolbar-list-alunos">
            <Col xs={10} md={10} className="no-p-left no-p-right text-left">

              <div className="top-left-table-users-finals">
                {/* <h3 className="label-table no-m-bottom">Alunos</h3> */}
                <ButtonToolbar>
                  <h4 className="marginBottom">Alunos Registrados</h4>
                  <ToggleButtonGroup className="group-button" type="radio" name="options" defaultValue={1}>
                    <ToggleButton value={1} onClick={() => this.filterUsersByStatus(1)} bsSize="xsmall">Todos</ToggleButton>
                    <ToggleButton bsSize="xsmall" value={2} onClick={() => this.filterUsersByStatus(2)}>Ativos</ToggleButton>
                    <ToggleButton bsSize="xsmall" value={3} onClick={() => this.filterUsersByStatus(3)}>Inativos</ToggleButton>
                  </ToggleButtonGroup>
                </ButtonToolbar>
                <ButtonToolbar className="group-button2">
                  <h4 className="marginBottom">Contrato</h4>
                  <ToggleButtonGroup className="group-button" type="radio" name="options" defaultValue={1}>
                    <ToggleButton value={1} onClick={() => this.filterUsersByContractDate(1)} bsSize="xsmall">Todos</ToggleButton>
                    <ToggleButton bsSize="xsmall" value={2} onClick={() => this.filterUsersByContractDate(2)}>Vencendo</ToggleButton>
                    <ToggleButton bsSize="xsmall" value={3} onClick={() => this.filterUsersByContractDate(3)}>Vencidos</ToggleButton>
                  </ToggleButtonGroup>
                </ButtonToolbar>
                <ButtonToolbar className="group-button2">
                  <h4 className="marginBottom">Treino</h4>
                  <ToggleButtonGroup className="group-button" type="radio" name="options" defaultValue={1}>
                    <ToggleButton value={1} onClick={() => this.filterUsersByTimeTraining(1)} bsSize="xsmall">Todos</ToggleButton>
                    <ToggleButton bsSize="xsmall" value={4} onClick={() => this.filterUsersByTimeTraining(4)}>Ativos</ToggleButton>
                    <ToggleButton bsSize="xsmall" value={2} onClick={() => this.filterUsersByTimeTraining(2)}>Vencendo</ToggleButton>
                    <ToggleButton bsSize="xsmall" value={3} onClick={() => this.filterUsersByTimeTraining(3)}>Vencidos</ToggleButton>
                  </ToggleButtonGroup>
                </ButtonToolbar>
              </div>
            </Col>
            <Col xs={2} md={2} className="no-p-left no-p-right text-left">
              <FormControl
                name="search_table_users"
                type="text"
                value={this.state.search_table_users}
                placeholder="Pesquisar aluno"
                onChange={(event) => this.onInputChange(event.target)} />
            </Col>
          </Row>
        </Grid>

        <Well>
          <Table responsive>
            <thead>
              <tr>
                <th>Nome</th>
                <th>Idade</th>
                <th>Serviço</th>
                <th>Contrato</th>
                <th>Treino</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {this.renderAlunosFinais()}
            </tbody>
          </Table>


        </Well>


        {this.state.paginationComponent}
        {/* <If test={this.state.usersCount &&
          this.state.search_table_users == '' &&
          this.state.filter_by_time_training == 1}>

          
        </If> */}
      </div>

    );
  }
}

export default ListAlunos;



// WEBPACK FOOTER //
// src/components/alunos/users-list.js